import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { AdPlacementMultiImagePreview } from '@bingads-webui-campaign-react/ad-placement-preview';
import { ImageExperienceImage } from '../model/image-experience-image';
import C from '../constants';

export class MultiImageGeneral extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    _.defaults(this, C.imageAdExtSettings[this.props.previewType]);
  }

  render() {
    const {
      images,
      previewType,
      previewTexts,
      i18n,
    } = this.props;

    return (
      <div className="new-responsive-ad-preview-container" >
        <AdPlacementMultiImagePreview
          previewType={previewType}
          previewTexts={previewTexts}
          images={images}
          i18n={i18n}
          previewContentClassName={this.previewContentClassName}
          imagePreviewHeight={this.imagePreviewHeight}
        />

        <div className="preview-type-string">
          {this.props.i18n.getString(this.previewTypeStringKey)}
        </div>
      </div>
    );
  }
}

MultiImageGeneral.propTypes = {
  images: PropTypes.arrayOf(PropTypes.instanceOf(ImageExperienceImage)).isRequired,
  previewTexts: PropTypes.shape({
    longHeadline: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  previewType: PropTypes.string.isRequired,
};

